import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const LocationEllipseFill48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M19.5615 25.7585L19.9443 27.947C18.2438 28.248 16.7574 28.727 15.583 29.3142C13.4114 30.4001 12.9307 31.4808 12.9307 32.0007C12.9309 32.5207 13.4119 33.6006 15.583 34.6863C17.6193 35.7044 20.5909 36.4001 23.9971 36.4001C27.4033 36.4001 30.3748 35.7044 32.4111 34.6863C34.5826 33.6005 35.0633 32.5207 35.0635 32.0007C35.0634 31.4808 34.583 30.4001 32.4111 29.3142C31.9599 29.0886 31.4624 28.88 30.9248 28.6902L31.7852 26.5906C35.1437 27.8011 37.331 29.7725 37.3311 32.0007C37.3307 35.6825 31.3607 38.6667 23.9971 38.6667C16.6336 38.6666 10.6644 35.6824 10.6641 32.0007C10.6641 29.1209 14.316 26.6673 19.4307 25.7351L19.5615 25.7585ZM31.2822 10.8532C33.2554 10.033 35.3048 12.0715 34.4736 14.0495L26.0273 34.6667L23.2197 33.5017L21.5205 23.7995L11.8281 22.1101L10.6641 19.2995L31.2822 10.8532Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
